const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const {TransitionGroup, CSSTransition} = require("react-transition-group");
const _ = require("lodash");

const Link = require("../../core/view/Link");
const QuantitySelect = require("../QuantitySelect");
const withVaultDispatch = require("../../core/hoc/withVaultDispatch");
const withContainerDims = require("../../core/hoc/withContainerDims");
const OpsCart = require("../vault/OpsCart");
const AT = require("../../core/vault/ActionTypes");
const URLMake = require("../../../shared/URLMake");
const BookstoreUtil = require("../../../shared/BookstoreUtil");
const StoreUtil = require("../../../shared/StoreUtil");
const StoreBundleUtil = require("../../../shared/StoreBundleUtil");
const StringUtil = require("../../../shared/StringUtil");
const CopyTable = require("../data/CopyTable");
const DeleteIcon = require("../DeleteIcon");
const {TriangleAlert} = require("lucide-react");
const CartItemIcon = require("./CartItemIcon");
const GiftRecipientInfo = require("./GiftRecipientInfo");
const GiftInlineModal = require("./GiftInlineModal");
const OfficeModal = require("../modals/OfficeModal");
const modalStyles = require("../modals/styles/OfficeModalsGeneral.css");
const ApparelSection = require("../ApparelSection");
const {track} = require("../../core/util/Mixpanel");
const {getFeatureFlag} = require("../../core/util/FeatureFlags");
const styles = require("./styles/Cart.css");

/**
 * Page state for the storefront product for a cart line (matches inline removed-row
 * link behavior in renderItemRowOld).
 */
function productLinkStateForRemovedCartItem(cartItem) {
	const sku = cartItem.sku;
	const itemType = OpsCart.getItemType(cartItem);
	const isFullScienceSet = StoreUtil.isScienceFullSet(cartItem);
	const isFullSet = StoreUtil.isFullSet(cartItem);
	const isScienceItem = StoreUtil.isScienceItem(cartItem);

	// Full-set SKUs are typed as "book" by getTypeFromSKU but are not in
	// BookstoreUtil.skuMap; handle sets before getBookInfoFromSKU.
	if (isFullScienceSet) {
		return URLMake.forScienceBookLevel(cartItem.grade);
	}
	if (isFullSet) {
		return URLMake.forBookLevel(cartItem.grade);
	}

	let bookHash;
	if (itemType === "book") {
		const bookInfo = BookstoreUtil.getBookInfoFromSKU(sku);
		bookHash = bookInfo && bookInfo.bookHash;
	}

	if (isScienceItem && bookHash) {
		return URLMake.forScienceBook(bookHash);
	}
	if (itemType === "book" && bookHash) {
		return URLMake.forBook(bookHash);
	}
	if (itemType === "apparel") {
		return URLMake.forApparel(cartItem.options.apparelHash);
	}
	if (itemType === "gift") {
		return URLMake.forGifting();
	}
	return URLMake.forEnroll();
}

// Stable sort so display index matches remove/undo index (same sku → order by displayName)
const sortSubscriptionsByDisplayName = items =>
	_.sortBy(items, [i => _.get(i, "options.displayName", "")]);

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultDispatch(Component);
	Component = withContainerDims(Component);
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "Cart",

		propTypes: {
			cart: PT.object.isRequired,
			inModal: PT.bool,
			tabIndexStart: PT.number,
			// If user cannot buy subscription items, "parent" or "other"
			subscriptionsErrorType: PT.string,
			step: PT.string,

			// Injected by HOCs
			dispatch: PT.func.isRequired,
			containerDims: PT.shape({
				width: PT.number.isRequired,
				height: PT.number.isRequired,
				left: PT.number.isRequired,
				top: PT.number.isRequired,
				windowWidth: PT.number.isRequired,
				windowHeight: PT.number.isRequired,
			}).isRequired,
		},

		getInitialState: function() {
			return {
				lastRemovedItem: null,
				lastRemovedItemWithName: null,
				originalNameMap: {},
				editingItemId: null,
				showApparelModal: false,
			};
		},

		UNSAFE_componentWillMount: function() {
			const items = OpsCart.getNumItemsWithBundles(this.props.cart);
			this.makeSmallRows = items.length > 8 || this.props.inModal;
		},

		transitionProps: {
			classNames: {
				enter: styles.rowEnter,
				enterActive: styles.rowEnterActive,
				exit: styles.rowExit,
				exitActive: styles.rowExitActive,
			},
			timeout: {enter: 700, exit: 700},
		},

		removeCartItem: function(cartItem) {
			this.props.dispatch({
				type: AT.REMOVE_ITEM_FROM_CART,
				cartItem,
			});
			const isFullSet = StoreUtil.isFullSet(cartItem);
			const itemType = _.startCase(OpsCart.getItemType(cartItem));
			const cartItems = OpsCart.getItemsWithBundles(this.props.cart.items);
			let itemGroup = OpsCart["getSorted" + itemType + "Items"](cartItems);
			if (itemType === "Book") {
				itemGroup = OpsCart.groupBooksIntoSets(itemGroup);
			} else if (itemType === "Subscription") {
				itemGroup = sortSubscriptionsByDisplayName(itemGroup);
			} else if (itemType === "Bundle") {
				itemGroup = sortSubscriptionsByDisplayName(itemGroup);
			}

			const removalData = {
				isRemovedItem: true,
				sortedIndex: _.findIndex(itemGroup, cartItem),
				collapsedItems: isFullSet ? cartItem.subitems : [],
			};
			this.setState({
				lastRemovedItem: _.extend({}, removalData, cartItem),
				lastRemovedItemWithName: _.extend(
					{},
					removalData,
					this.withOriginalName(cartItem)
				),
			});
		},

		readdRemovedItem: function(cartItem) {
			// cartItem is the stored lastRemovedItem (spliced into the list for the removed bar),
			// so it has the full sku/quantity/options needed to re-add.
			this.props.dispatch({
				type: AT.ADD_ITEM_TO_CART,
				sku: cartItem.sku,
				quantity: cartItem.quantity,
				options: cartItem.options || {},
				skipModal: true,
			});
			this.setState({
				lastRemovedItem: null,
				lastRemovedItemWithName: null,
			});
		},

		updateItemQuantity: function(cartItem, quantity) {
			this.props.dispatch({
				type: AT.UPDATE_CART_ITEM_QUANTITY,
				cartItem,
				quantity,
			});
		},

		//GiftCode stuff
		handleGiftEditClick: function(id) {
			if (id === this.state.editingItemId) {
				//this is if they click the Edit button again
				this.handleGiftCloseModal();
			} else {
				this.setState({editingItemId: id});
			}
		},

		handleGiftCloseModal: function() {
			this.setState({editingItemId: null});
		},

		handleGiftSaveModal: function(cartItem, updatedOptions) {
			this.props.dispatch({
				type: AT.UPDATE_CART_ITEM_OPTIONS,
				cartItems: [cartItem],
				options: updatedOptions,
			});
			this.handleGiftCloseModal();
		},

		renderAddButton: function(key, label, onClick, disabled) {
			return (
				<CSSTransition {...this.transitionProps} key={"add-btn-" + key}>
					<div className={styles.addItemRow}>
						<button
							className={styles.addItemButton}
							onClick={onClick}
							disabled={disabled}
						>
							{"+ " + label}
						</button>
					</div>
				</CSSTransition>
			);
		},

		renderAddLink: function(key, label, to) {
			return (
				<CSSTransition {...this.transitionProps} key={"add-btn-" + key}>
					<div className={styles.addItemRow}>
						<Link to={to} className={styles.addItemButton}>
							{"+ " + label}
						</Link>
					</div>
				</CSSTransition>
			);
		},

		clearRemovedItem: function() {
			this.setState({lastRemovedItem: null, lastRemovedItemWithName: null});
		},

		addSubscription: function(lastItem) {
			this.clearRemovedItem();
			const name = OpsCart.getNextPlaceholderName(this.props.cart.items);
			const planType = lastItem?.sku === "beast-monthly" ? "monthly" : "yearly";
			this.props.dispatch({
				type: AT.ADD_SUBSCRIPTIONS_TO_CART,
				additions: [{type: planType, displayName: name}],
				skipModal: true,
			});
		},

		addCode: function() {
			this.clearRemovedItem();
			this.props.dispatch({
				type: AT.ADD_ITEM_TO_CART,
				sku: "beast-bulk-codes",
				quantity: 1,
				options: {},
				skipModal: true,
			});
		},

		renderTitleRow: function(name, forSubscription) {
			let moreInfoTitle = "";
			if (name !== "Gifts" && !forSubscription) {
				moreInfoTitle = "Quantity";
			}

			return (
				<CSSTransition {...this.transitionProps} key={"title-row-" + name}>
					<div className={styles.tRow} key={"title-row-" + name}>
						<div className={styles.typeTitle}>{name}</div>
						<div className={styles.qtyTitle}>{moreInfoTitle}</div>
						<div className={styles.priceTitle}>{"PRICE"}</div>
					</div>
				</CSSTransition>
			);
		},

		renderItemRowOld: function(data) {
			const {itemsOfType, cartItem, i, makeSmall, allItems, coupon} = data;
			const tabIndexBase = data.tabIndexBase ?? 0;
			/* tabIndexStart is an optional prop that could be passed in if we needed a tabbable option before the items in the cart.
		tabIndexBase should be the number that we start our current tab index from - so it should count all of the tabbable inputs before our current one.
		i is the index of the item in our current itemsOfType (so if we're on the 2nd subscription of 4, for example).
		We do 2*i as a buffer in case there's any items that need more tabbable inputs than just one, and tabIndex doesn't need to be strictly sequential (it's okay if we skip a few numbers and go 1, 3, 5)
		*/
			const tabIndexOffset =
				(this.props.tabIndexStart ?? 0) + tabIndexBase + 2 * i;
			const isBundleItemWithCode = StoreUtil.isBundleItemWithCode(cartItem);
			const showWarning = isBundleItemWithCode ? "" : data.showWarning;
			const sku = cartItem.sku;
			const isFullScienceSet = StoreUtil.isScienceFullSet(cartItem);
			const isFullSet = StoreUtil.isFullSet(cartItem);
			let nameText;
			let bundleGrades = [];
			let redText = null;
			let redText2 = null;
			let redText3 = null;

			if (sku === "bundle") {
				bundleGrades = cartItem.options.bundleIDs.sort();
				nameText = bundleGrades.map(b => {
					return (
						<span key={"name-" + b}>
							{OpsCart.getItemName({sku: b})}
							<br />
						</span>
					);
				});

				if (
					coupon &&
					coupon.typeInfo === "new-sub-extension-referral" &&
					i === 0
				) {
					redText = `+ ${coupon.lengthToExtend.num} Free ${_.capitalize(
						coupon.lengthToExtend.unitOfTime
					)}s`;
					redText2 = (
						<div>
							(coupon limited to one <b>yearly</b> subscription per <b>new</b>{" "}
							account)
						</div>
					);
					redText3 = (
						<div className={styles.nameE}>
							<b>+ 3 Free Months</b> (coupon limited to one <b>yearly</b>{" "}
							subscription per <b>new</b> account)
						</div>
					);
				}
			} else {
				nameText = OpsCart.getItemName(cartItem);
				nameText = nameText.replace(/\s*Subscription\s*/gi, " ").trim();
				const numBundles = OpsCart.getNumSubscriptionsByType(allItems).bundle;
				const nonRemovedItemsOfType = itemsOfType.filter(
					it => !it.isRemovedItem
				);
				const nonRemovedIndexOfItem = nonRemovedItemsOfType.indexOf(
					itemsOfType[i]
				);
				const isFirstYearly =
					sku === "beast-yearly" &&
					!itemsOfType[i].isRemovedItem &&
					!StoreUtil.hasYearlySubscriptions(
						nonRemovedItemsOfType.slice(0, nonRemovedIndexOfItem)
					);
				if (
					coupon &&
					coupon.typeInfo === "new-sub-extension-referral" &&
					isFirstYearly &&
					!numBundles
				) {
					redText = `+ ${coupon.lengthToExtend.num} Free ${_.capitalize(
						coupon.lengthToExtend.unitOfTime
					)}s`;
					redText2 = (
						<div>
							(coupon limited to one <b>yearly</b> subscription per <b>new</b>{" "}
							account)
						</div>
					);
					redText3 = (
						<div className={styles.nameE}>
							<b>+ 3 Free Months</b> (coupon limited to one <b>yearly</b>{" "}
							subscription per <b>new</b> account)
						</div>
					);
				}
			}

			const itemType = OpsCart.getItemType(cartItem);
			const studentName = cartItem.options.displayName;

			let key = itemType + "-" + sku;
			let giftRecipientInfoBlock = <></>;
			if (studentName) {
				key = itemType + "-" + this.getSortingItemName(cartItem);
			} else if (itemType === "gift") {
				key += "-" + cartItem.options.uniqueId;
				giftRecipientInfoBlock = (
					<GiftRecipientInfo
						recipientEmail={cartItem.options.recipientEmail}
						senderName={cartItem.options.senderName}
						studentName={cartItem.options.studentName}
						deliveryDate={cartItem.options.deliveryDate}
						personalizedMessage={cartItem.options.personalizedMessage}
						onEdit={() => this.handleGiftEditClick(cartItem.options.uniqueId)}
					/>
				);
			}
			// this must be a code bundle, append the bundleID to the key
			else if (!studentName && sku === "bundle") {
				key += "-" + cartItem.options.bundleIDs[0];
			}

			let apparelHash;
			let itemDetails;
			if (isFullSet) {
				itemDetails = {
					isFullSet: true,
					isFullScienceSet,
					grade: cartItem.grade,
					books: cartItem.subitems,
				};
			} else if (itemType === "book") {
				const bookInfo = BookstoreUtil.getBookInfoFromSKU(sku);
				itemDetails = bookInfo;
			} else if (itemType === "bundle") {
				const sortedIDs = bundleGrades.sort();
				itemDetails = {level: StoreBundleUtil.getBundleGrade(sortedIDs[0])};
			} else if (itemType === "apparel") {
				apparelHash = cartItem.options.apparelHash;
				itemDetails = {
					apparelHash,
					apparelName: nameText,
				};
			}
			if (cartItem.isRemovedItem) {
				const removedClass = makeSmall
					? styles.removedRowSmall
					: styles.removedRow;
				const onReAdd = () => {
					track("Cart Item Re-Added", {sku: cartItem.sku});
					this.readdRemovedItem(cartItem);
				};

				const onKeyPress = evt => {
					if (evt.which === 13) {
						onReAdd();
					}
				};

				const linkTo = productLinkStateForRemovedCartItem(cartItem);
				let removedName, verb;
				if (itemType === "bundle") {
					if (bundleGrades.length > 1) {
						removedName = "Bundles";
						verb = " were";
					} else {
						removedName = OpsCart.getItemName({sku: bundleGrades[0]});
						verb = " was";
					}
				} else {
					removedName = nameText;
					verb = " was";
				}
				return (
					<CSSTransition {...this.transitionProps} key={"removed-item-" + key}>
						<div className={removedClass}>
							<div className={styles.removedText}>
								<Link className={styles.removedLink} to={linkTo}>
									{"Beast Academy " + removedName}
								</Link>
								{verb + " removed from your cart."}
							</div>
							<div className={styles.removedSpacing} />
							<div
								className={styles.removedUndo}
								onClick={onReAdd}
								onKeyPress={onKeyPress}
								tabIndex={tabIndexOffset}
							>
								Undo
							</div>
						</div>
					</CSSTransition>
				);
			}
			const onDeleteClick = () => {
				track("Cart Item Removed", {sku: cartItem.sku});
				this.removeCartItem(cartItem);
			};
			let rowClass = makeSmall ? styles.rowSmall : styles.row;
			if (itemType === "bundle") {
				rowClass = makeSmall ? styles.rowBundleSmall : styles.rowBundle;
			} else if (itemType === "gift") {
				rowClass = styles.rowBundle;
			} else if (itemType === "book") {
				rowClass += " " + styles.rowBook;
			}
			if (showWarning) rowClass += " " + styles.errorBorder;
			if (this.compareToLastRemovedItem(cartItem)) {
				rowClass += " " + styles.rowBeingRemoved;
				if (i === itemsOfType.length - 2) {
					rowClass += " " + styles.rowNoBorder;
				}
			}
			if (i === itemsOfType.length - 1) {
				rowClass += " " + styles.rowNoBorder;
			}

			if (redText3 && itemType !== "bundle") {
				rowClass += " " + styles.rowWide;
			}

			let price;
			const itemsToUse = allItems.filter(it => !it.isRemovedItem);
			const basePrice = OpsCart.getItemPriceString(itemsToUse, cartItem);
			if (OpsCart.itemHasDiscount(cartItem, allItems)) {
				const nondiscountedPrice = OpsCart.getItemPriceString(
					itemsToUse,
					cartItem,
					{skipDiscounts: true}
				);
				price = (
					<div className={styles.discountedPrices}>
						<div className={styles.originalPrice}>{nondiscountedPrice}</div>
						<div className={styles.currentPrice}>{basePrice}</div>
					</div>
				);
			} else {
				price = <div className={styles.price}>{basePrice}</div>;
			}

			let quantityEl = null;
			if (itemType === "gift") {
				quantityEl = (
					<div className={styles.desktopOnly}>{giftRecipientInfoBlock}</div>
				);
			} else if (
				isFullSet ||
				itemType === "book" ||
				itemType === "apparel" ||
				itemType === "code" ||
				isBundleItemWithCode
			) {
				quantityEl = (
					<QuantitySelect
						className={styles.qty}
						minQty={0}
						minSelectable={1}
						initialValue={cartItem.quantity}
						updateQuantity={qty => this.updateItemQuantity(cartItem, qty)}
						showUpdate={true}
						tabIndex={tabIndexOffset}
					/>
				);
			}

			let subrows;
			if (itemType === "bundle") {
				const subItems = OpsCart.getBundleSubitems(cartItem);
				const showDefermentStatus = getFeatureFlag(
					"ENABLE_BA_BUNDLE_DEFERMENT"
				);
				const defermentSuffix = showDefermentStatus ? (
					<span
						className={
							cartItem.options.bookLevelDeferred
								? styles.defermentPending
								: styles.defermentConfirmed
						}
					>
						{cartItem.options.bookLevelDeferred ? " — pending" : " — confirmed"}
					</span>
				) : null;
				const bookRows = subItems.books.map((book, n) => (
					<div key={bundleGrades[n]}>
						{book}
						{defermentSuffix}
					</div>
				));
				subrows = (
					<div className={styles.subrows}>
						<div>
							<b>{"Includes:"}</b>
						</div>
						<div>{subItems.subscription}</div>
						{bookRows}
					</div>
				);
			}

			const subscriptionsWarning = showWarning ? (
				<div className={styles.warning}>
					{CopyTable.getSubscriptionsWarning(showWarning, styles)}
				</div>
			) : null;

			return (
				<CSSTransition {...this.transitionProps} key={key}>
					<div className={rowClass}>
						<div className={styles.mainRow}>
							<div className={styles.rowCol1}>
								<div className={styles.dContainer}>
									<DeleteIcon onDelete={onDeleteClick} />
								</div>
								<div className={styles.nameImage}>
									<div className={styles.cContainer}>
										<CartItemIcon
											className={styles.cLink}
											itemType={itemType}
											itemDetails={itemDetails}
											hideGrade={bundleGrades.length > 1}
											isSmall={makeSmall}
										/>
									</div>
									<div className={styles.nameA}>
										{"Beast Academy"}
										<br />
										{nameText}
										<div className={styles.nameC}>{redText}</div>
										<div className={styles.nameD}>{redText2}</div>
									</div>
									<div className={styles.nameB}>{nameText}</div>
								</div>
							</div>
							<div className={styles.rowCol2}>{quantityEl}</div>
							<div className={styles.rowCol3}>{price}</div>
						</div>
						<div className={styles.mobileOnly}>{giftRecipientInfoBlock}</div>
						{this.state.editingItemId === cartItem.options.uniqueId && (
							<GiftInlineModal
								recipientEmail={cartItem.options.recipientEmail}
								senderName={cartItem.options.senderName}
								studentName={cartItem.options.studentName}
								deliveryDate={cartItem.options.deliveryDate}
								deliveryDateUTC={cartItem.options.deliveryDateUTC}
								personalizedMessage={cartItem.options.personalizedMessage}
								onClose={() => this.handleGiftCloseModal()}
								onSave={updatedOptions => {
									this.handleGiftSaveModal(cartItem, updatedOptions);
								}}
							/>
						)}
						{redText3}
						{subrows}
						{subscriptionsWarning}
					</div>
				</CSSTransition>
			);
		},

		renderItemRow: function(data) {
			return this.renderItemRowOld(data);
		},

		getSortingItemName: function(item) {
			const name = item.options.displayName;
			if (item.isRemovedItem) {
				//Already the original name, using originalNameMap can lead to bugs
				return name;
			}
			return this.state.originalNameMap[name] || name;
		},

		// Returns the item if it doesn't have a displayName option or if
		// its name hasn't been changed; otherwise returns a new object
		// exactly matching item except with the original name
		withOriginalName: function(item) {
			const name = _.get(item, "options.displayName");
			if (name && this.state.originalNameMap[name]) {
				return _.set(
					_.cloneDeep(item),
					"options.displayName",
					this.state.originalNameMap[name]
				);
			} else {
				return item;
			}
		},

		// Checks if an item matches the lastRemovedItem, accounting for name changes
		compareToLastRemovedItem: function(item) {
			const lastRemovedItem = this.state.lastRemovedItemWithName;
			if (!item || !lastRemovedItem) {
				return false;
			}
			//Make sure the item has its original name
			return OpsCart.areItemsEqual(
				this.withOriginalName(item),
				lastRemovedItem
			);
		},

		render: function() {
			const {cart, subscriptionsErrorType} = this.props;
			const {lastRemovedItem, lastRemovedItemWithName} = this.state;
			const showWarning = subscriptionsErrorType;
			const {coupon} = cart;
			// This is adjusted cart items with things that are bundled.
			// turn bookItems into
			const cartItems = OpsCart.getItemsWithBundles(this.props.cart.items);
			const sortedBookItems = OpsCart.getSortedBookItems(cartItems);
			const bookItems = OpsCart.groupBooksIntoSets(sortedBookItems);
			const subscriptionItems = OpsCart.getSortedSubscriptionItems(cartItems);
			const bundleItems = OpsCart.getSortedBundleItems(cartItems);

			const apparelItems = OpsCart.getSortedApparelItems(cartItems);
			const codeItems = OpsCart.getSortedCodeItems(cartItems);
			const giftItems = OpsCart.getSortedGiftItems(cartItems);
			const emptyCart = !cartItems.length;
			//Always make sure the last deleted item is in the list of items (even if
			//the original is still there)
			if (lastRemovedItem) {
				const lastRemovedItemType = OpsCart.getItemType(lastRemovedItem);
				const itemMap = {
					book: bookItems,
					subscription: subscriptionItems,
					bundle: bundleItems,
					apparel: apparelItems,
					code: codeItems,
					gift: giftItems,
				};
				const itemGroup = itemMap[lastRemovedItemType];
				// Use raw items for comparison so we match lastRemovedItem (raw)
				let groupForCompare = itemGroup;
				if (lastRemovedItemType === "subscription") {
					groupForCompare = subscriptionItems;
				} else if (lastRemovedItemType === "bundle") {
					groupForCompare = bundleItems;
				}
				let insertIndex = lastRemovedItemWithName.sortedIndex;
				if (this.compareToLastRemovedItem(groupForCompare[insertIndex])) {
					insertIndex++;
				} else {
					const unremovedIndex = _.findIndex(groupForCompare, i =>
						this.compareToLastRemovedItem(i)
					);
					if (unremovedIndex !== -1) {
						const unremovedItem = itemGroup.splice(unremovedIndex, 1);
						itemGroup.splice(insertIndex, 0, unremovedItem[0]);
						insertIndex++;
					}
				}
				itemGroup.splice(insertIndex, 0, lastRemovedItem);
			}
			const makeSmallRows = this.makeSmallRows;
			const allItems = cart.items;

			const subscriptionRows = subscriptionItems.map((s, i) => {
				return this.renderItemRow({
					itemsOfType: subscriptionItems,
					cartItem: s,
					i,
					tabIndexBase: 0,
					makeSmallRows,
					showWarning,
					allItems,
					coupon,
				});
			});
			const codeRows = codeItems.map((s, i) => {
				return this.renderItemRow({
					itemsOfType: codeItems,
					cartItem: s,
					i,
					tabIndexBase: 2 * subscriptionItems.length,
					makeSmallRows,
					allItems,
				});
			});
			const bundleRows = bundleItems.map((s, i) => {
				return this.renderItemRow({
					itemsOfType: bundleItems,
					cartItem: s,
					i,
					tabIndexBase: 2 * (subscriptionItems.length + codeItems.length),
					makeSmallRows,
					showWarning,
					allItems,
					coupon,
				});
			});
			const individualBookRows = bookItems.map((b, i) => {
				return this.renderItemRow({
					itemsOfType: bookItems,
					cartItem: b,
					tabIndexBase:
						2 *
						(subscriptionItems.length + codeItems.length + bundleItems.length),
					i,
					makeSmallRows,
					allItems,
				});
			});
			const apparelRows = apparelItems.map((s, i) => {
				return this.renderItemRow({
					itemsOfType: apparelItems,
					cartItem: s,
					i,
					tabIndexBase:
						2 *
						(subscriptionItems.length + codeItems.length + bundleItems.length),
					makeSmallRows,
					allItems,
				});
			});

			const giftRows = giftItems.map((s, i) => {
				return this.renderItemRow({
					itemsOfType: giftItems,
					cartItem: s,
					i,
					makeSmallRows,
					allItems,
				});
			});
			const hasDiscountedBooks = !!_.find(
				sortedBookItems,
				i => i.quantity >= 5
			);

			const hasDiscountedCodes = !!_.find(codeItems, i => i.quantity >= 5);

			let bookDiscount = null;
			let codeDiscount = null;
			let discountModal = null;

			let subtotal = null;
			//Always show discount
			if (this.props.inModal) {
				subtotal = (
					<div className={styles.subtotal}>
						<div className={styles.subtitle}>Subtotal</div>
						<div className={styles.subPrice}>
							{StringUtil.toPrice(cart.prices.subtotal)}
						</div>
					</div>
				);
				discountModal = hasDiscountedBooks ? (
					<div className={styles.discountsModal}>
						{CopyTable.getBookOffers(styles.offer, styles.oPercent)}
					</div>
				) : null;
			} else {
				bookDiscount = hasDiscountedBooks ? (
					<div className={styles.discounts}>
						{CopyTable.getBookOffers(styles.offer, styles.oPercent)}
					</div>
				) : null;
				codeDiscount = hasDiscountedCodes ? (
					<div className={styles.discounts}>
						{CopyTable.getCodeOffers(styles.offer, styles.oPercent)}
					</div>
				) : null;
			}
			let mainClass;
			if (this.props.inModal) {
				mainClass = styles.modalMain;
			} else {
				mainClass = styles.main;
			}

			if (emptyCart) {
				mainClass += " " + styles.mainEmpty;
			}

			let booksTitle, onlineTitle, bundlesTitle, apparelTitle, giftTitle;
			let codesTitle;
			/* Section titles: order must match JSX (online → codes → bundles → books → apparel → gifts). */
			if (subscriptionRows.length && codeRows.length) {
				onlineTitle = this.renderTitleRow("Subscriptions", true);
				codesTitle = this.renderTitleRow("Codes", false);
			} else if (subscriptionRows.length) {
				onlineTitle = this.renderTitleRow("Subscriptions", true);
			} else if (codeRows.length) {
				codesTitle = this.renderTitleRow("Codes", false);
			}
			if (bundleRows.length) {
				const bundlesTitleForSubscription = !_.some(
					bundleItems,
					StoreUtil.isBundleItemWithCode
				);
				bundlesTitle = this.renderTitleRow(
					"Bundles",
					bundlesTitleForSubscription
				);
			}
			if (individualBookRows.length) {
				booksTitle = this.renderTitleRow("Books", false);
			}
			if (apparelRows.length) {
				apparelTitle = this.renderTitleRow("Apparel", false);
			}
			if (giftRows.length) {
				giftTitle = this.renderTitleRow("Gifts", false);
			}

			const canAddSub = StoreUtil.canAddMoreSubscriptions(allItems);

			let maxSubsBadge = null;
			if (!canAddSub) {
				maxSubsBadge = (
					<CSSTransition {...this.transitionProps} key="max-subs-badge">
						<div className={styles.maxSubsBadge}>
							<TriangleAlert className={styles.maxSubsBadgeIcon} size={32} />
							<div>
								<strong>Family accounts allow up to 6 subscriptions.</strong>
								{" Consider a "}
								<Link
									to={URLMake.forSaveWithFriends()}
									className={styles.maxSubsBadgeLink}
								>
									Bulk Order
								</Link>
								{" or "}
								<Link
									to={URLMake.forEducators()}
									className={styles.maxSubsBadgeLink}
								>
									School Account
								</Link>
								{" to enroll more students"}
							</div>
						</div>
					</CSSTransition>
				);
			}

			let apparelModal = null;
			if (this.state.showApparelModal) {
				apparelModal = (
					<OfficeModal
						onClose={() => this.setState({showApparelModal: false})}
						level={"overBar"}
						portalContainer={null}
						closeOnBackdropClick={true}
						modalClass={styles.apparelModal}
						closeClass={modalStyles.closeButtonSmall}
					>
						<ApparelSection
							apparelHash={"shirt-beast"}
							addApparel={() => this.setState({showApparelModal: false})}
						/>
					</OfficeModal>
				);
			}

			return (
				<div className={mainClass}>
					{discountModal}
					{apparelModal}
					<div className={styles.table}>
						<TransitionGroup component="div">
							{onlineTitle}
							{subscriptionRows}
							{codesTitle}
							{codeRows}
							{bundlesTitle}
							{bundleRows}
							{maxSubsBadge}
							{booksTitle}
							{individualBookRows}
							{apparelTitle}
							{apparelRows}
							{giftTitle}
							{giftRows}
						</TransitionGroup>
					</div>
					{subtotal}
					{codeDiscount}
					{bookDiscount}
				</div>
			);
		},
	})
);
